import Hashids from 'hashids';

const hashids = new Hashids('magna-sales-portal', 5);

export const encodeId = (id) => {
    if (!id) return;
    const encode = hashids.encode(id);
    return encode;
};

export const decodeId = (id) => {
    if (!id || typeof id !== 'string') return id;
    try {
        const decoded = hashids.decode(id);
        return decoded.length > 0 ? decoded[0] : id;
    } catch (e) {
        return id;
    }
};

export const recursiveDecode = (data) => {
    if (!data || typeof data !== 'object') return data;

    if (Array.isArray(data)) {
        return data.map(recursiveDecode);
    }

    const newData = { ...data };
    Object.keys(newData).forEach((key) => {
        const value = newData[key];
        if (typeof value === 'string' && (key === 'id' || key.endsWith('_id'))) {
            const decoded = hashids.decode(value);
            if (decoded.length > 0) {
                newData[key] = decoded[0];
            }
        } else if (Array.isArray(value) && key.endsWith('_ids')) {
            newData[key] = value.map((val) => {
                if (typeof val === 'string') {
                    const decoded = hashids.decode(val);
                    return decoded.length > 0 ? decoded[0] : val;
                }
                return val;
            });
        } else if (typeof value === 'object') {
            newData[key] = recursiveDecode(value);
        }
    });
    return newData;
};
